import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import { useBreakpointValue } from '@chakra-ui/react'
import SectionsData from '../data/sections.json'

const HowNltWorksSection = dynamic(() => import('../../components/Sections/HowNltWorks'))
const HowNltWorksSectionMobile = dynamic(() => import('../../components/Sections/HowNltWorksMobile'))

const data = SectionsData.howNltWorks

const HowNltWorksSectionContainer: FC<{ content: { title: string, text: string } }> = ({ content }) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  return isMobile ? (
    <HowNltWorksSectionMobile
      image={data.image}
      imageAlt={data.imageAlt}
      itemsTitle={data.itemsTitle}
      items={data.items}
      descriptionTitle={data.descriptionTitle}
      description={data.description}
      hrefTitle={data.hrefTitle}
      content={content}
    />
  ) : (
    <HowNltWorksSection
      image={data.image}
      imageAlt={data.imageAlt}
      itemsTitle={data.itemsTitle}
      items={data.items}
      descriptionTitle={data.descriptionTitle}
      description={data.description}
      hrefTitle={data.hrefTitle}
      content={content}
    />
  )
}

export default HowNltWorksSectionContainer
